
<ws-wrapper
  :class="{
    'ws-icon ws-icon__wrapper flex items-center': wrap,
    circle: circle,
    [bgColorClass]: bgColor,
  }"
  :wrap="wrap"
  :style="sizes"
>
  <component
    :is="unloaded ? 'span' : 'inline-svg'"
    v-bind="$attrs"
    :class="classes"
    :src="iconUrl"
    :title="name"
    :style="sizes"
    :circle="circle"
    :data-test="'ws-icon-' + name"
    v-on="$listeners"
  >
    □
  </component>
  <slot></slot>
</ws-wrapper>
